import React from 'react';
import { config } from '../../data/config';

import './hero-subsidy.scss';

const GoldenEyeCareSubsidyHero = ({ }) => {
    return (
        <div className="hero-subsidy">
            <div className="hero-subsidy-internal" style={{ ...config.images.sponsor.heroBackgroundStyle, zIndex: 5, }}>

            </div>
        </div>
    );
};

export default GoldenEyeCareSubsidyHero;
